export default [
  {
    path: '',
    redirect: 'dashboard',
  },
  {
    path: 'dashboard',
    // Lazy: keeps the dashboard charts and data providers out of the entry chunk
    // until a Cloudsine staff user opens this route.
    component: () => import('../components/AdminDashboard.vue'),
    meta: {
      title: 'Admin',
      showWhenFeatureEnabled: 'cloudsine-staff',
    },
  },
  {
    path: 'rendering-engines',
    // Lazy: keeps the engines editor (and Policy consts it pulls in) out of the
    // unauthenticated index chunk until a staff user opens this route.
    component: () => import('../components/RenderingEnginesPage.vue'),
    meta: {
      title: 'Rendering Engines',
      showWhenFeatureEnabled: 'cloudsine-staff',
    },
  },
];
